module.exports = __webpack_public_path__ + "img/fum.f601893b.png";